import { call, put } from 'redux-saga/effects';
import {
  getAllPaymentsFailed,
  getAllPaymentsSuccess,
  upsertPaymentFailed,
  upsertPaymentSuccess,
  getOnlinePaymentInfoSuccess,
  getOnlinePaymentInfoFailure,
  getPaymentDebitsSuccess,
  getPaymentDebitsFailed,
} from '../../actions/payments';
import {
  GET_ALL_PAYMENTS,
  GET_PAYMENT_DEBITS,
  GET_ONLINE_PAYMENT_INFO,
  UPSERT_PAYMENT_URL,
} from '../../constants/urls';

import zfetch, {
  METHOD_GET,
  METHOD_POST,
} from '../../pages/common/utils/zfetch';
import { openErrorToast } from '../../reducers/uiLogic';
import { currentFlowTypeEnum } from '../../pages/common/components/constants';
import { genericErrorMsg } from '../../constants';

const upsertPayment = (body = {}) => {
  const options = {
    body: JSON.stringify(body),
    method: METHOD_POST,
  };
  return zfetch(UPSERT_PAYMENT_URL, options);
};

const getUpsertPayment = body => {
  const {
    amountBalance = 0,
    referenceID = '',
    workspaceID = '',
    paymentDate = '',
    currentFlow = currentFlowTypeEnum.FLOW_TYPE_LIMIT,
    isInvoicePayment = true,
  } = body;

  const payment = {
    amount: amountBalance,
    reference_id: referenceID,
    workspace_id: workspaceID,
    payment_date: paymentDate,
    flow_type: currentFlow,
    is_invoice_payment: isInvoicePayment,
  };
  return upsertPayment(payment).then(res => res.json());
};

export function* upsertPaymentSaga(action) {
  let paymentStatus = {};
  try {
    const jsonResponse = yield call(() => {
      return getUpsertPayment(action.payload);
    });
    const { success = 1 } = jsonResponse;
    paymentStatus = success;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(openErrorToast(genericErrorMsg));
    yield put(upsertPaymentFailed(err));
    return;
  }

  yield put(upsertPaymentSuccess(paymentStatus));
}

const getAllPayments = ({ workspaceId, flowType }) => {
  const options = {
    method: METHOD_GET,
    params: { workspace_id: workspaceId, flow_type: flowType },
  };
  return zfetch(GET_ALL_PAYMENTS, options);
};

export function* getAllPaymentsSaga(action) {
  let paymentsData = {};

  try {
    const response = yield getAllPayments(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    paymentsData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getAllPaymentsFailed(err));
    return;
  }
  yield put(getAllPaymentsSuccess(paymentsData));
}

const getOnlinePaymentInfo = ({
  workspaceID = '',
  flowType = '',
  companyID = '',
  paymentRequestID = '',
}) => {
  const options = {
    method: METHOD_GET,
    params: {
      workspace_id: workspaceID,
      flow_type: flowType,
      company_id: companyID,
      payment_request_id: paymentRequestID,
    },
  };
  return zfetch(GET_ONLINE_PAYMENT_INFO, options);
};

export function* getOnlinePaymentInfoSaga(action) {
  let paymentInfo = {};

  try {
    const response = yield getOnlinePaymentInfo(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    paymentInfo = data;
    if (
      !paymentInfo.country_id ||
      !paymentInfo.service_type ||
      !paymentInfo.company_id ||
      !paymentInfo.online_payments_flag ||
      !paymentInfo.user_details
    ) {
      yield put(getOnlinePaymentInfoFailure('Payment Params are missing'));
      yield put(openErrorToast('Payment Params are missing'));
      return;
    }
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getOnlinePaymentInfoFailure(err));
    return;
  }
  yield put(getOnlinePaymentInfoSuccess(paymentInfo));
}

const getPaymentsDebits = ({ workspaceId, flowType }) => {
  const options = {
    method: METHOD_GET,
    params: { workspace_id: workspaceId, flow_type: flowType },
  };
  return zfetch(GET_PAYMENT_DEBITS, options);
};

export function* getPaymentsDebitsSaga(action) {
  try {
    const response = yield getPaymentsDebits(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    yield put(getPaymentDebitsSuccess(data));
  } catch (error) {
    let err = error;

    if (error.response) {
      err = yield err.response;
    }
    yield put(getPaymentDebitsFailed(err));
  }
}
